/**
 * LOCATION: dashboard-business/src/pages/ForgotPassword.js
 * FA icons only — zero emojis, mobile responsive, clean design
 */

import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = 'https://janimony-backend.onrender.com/api';

const ForgotPassword = () => {
  const navigate  = useNavigate();
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('Please enter your email address'); return; }
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/auth/forgot-password`, { email });
      if (res.data.success) {
        setSuccess(true);
        setTimeout(() => navigate('/verify-otp', { state: { email } }), 2200);
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to send OTP. Please try again.');
    } finally { setLoading(false); }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&family=Syne:wght@700;800&display=swap');
        *{box-sizing:border-box;}
        .fp-page{min-height:100vh;background:linear-gradient(135deg,#0a0a0a 0%,#1a0533 55%,#0d1117 100%);display:flex;align-items:center;justify-content:center;padding:20px;font-family:'DM Sans',sans-serif;position:relative;overflow:hidden;}
        .fp-orb1{position:fixed;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(102,126,234,0.15),transparent 70%);top:-130px;right:-80px;pointer-events:none;}
        .fp-orb2{position:fixed;width:300px;height:300px;border-radius:50%;background:radial-gradient(circle,rgba(118,75,162,0.12),transparent 70%);bottom:-100px;left:-60px;pointer-events:none;}
        .fp-card{width:100%;max-width:440px;background:rgba(255,255,255,0.04);backdrop-filter:blur(20px);border:1px solid rgba(255,255,255,0.1);border-radius:24px;padding:44px 40px;position:relative;z-index:1;box-shadow:0 40px 80px rgba(0,0,0,0.5),inset 0 1px 0 rgba(255,255,255,0.08);}
        .fp-logo{display:flex;align-items:center;justify-content:center;gap:10px;margin-bottom:28px;}
        .fp-logo-icon{width:42px;height:42px;border-radius:13px;background:linear-gradient(135deg,#667eea,#764ba2);display:flex;align-items:center;justify-content:center;box-shadow:0 8px 20px rgba(102,126,234,0.4);}
        .fp-logo-name{font-family:'Syne',sans-serif;font-size:20px;font-weight:800;color:#fff;}
        .fp-icon-wrap{width:64px;height:64px;border-radius:18px;background:rgba(102,126,234,0.15);border:1px solid rgba(102,126,234,0.25);display:flex;align-items:center;justify-content:center;margin:0 auto 20px;}
        .fp-title{font-family:'Syne',sans-serif;font-size:24px;font-weight:800;color:#fff;text-align:center;margin-bottom:8px;}
        .fp-sub{font-size:14px;color:rgba(255,255,255,0.4);text-align:center;line-height:1.7;margin-bottom:28px;}
        .fp-alert{padding:12px 14px;border-radius:10px;font-size:13px;margin-bottom:18px;display:flex;align-items:flex-start;gap:8px;line-height:1.5;}
        .fp-err{background:rgba(239,68,68,0.1);border:1px solid rgba(239,68,68,0.3);color:#fca5a5;}
        .fp-grp{margin-bottom:20px;}
        .fp-lbl{display:block;font-size:11px;font-weight:700;color:rgba(255,255,255,0.4);margin-bottom:8px;letter-spacing:0.5px;text-transform:uppercase;}
        .fp-wrap{position:relative;}
        .fp-inp{width:100%;padding:13px 14px 13px 42px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:12px;color:#fff;font-size:14px;outline:none;font-family:'DM Sans',sans-serif;transition:all 0.2s;box-sizing:border-box;}
        .fp-inp::placeholder{color:rgba(255,255,255,0.22);}
        .fp-inp:focus{border-color:rgba(102,126,234,0.6);background:rgba(102,126,234,0.08);box-shadow:0 0 0 3px rgba(102,126,234,0.12);}
        .fp-ico{position:absolute;left:14px;top:50%;transform:translateY(-50%);color:rgba(255,255,255,0.3);font-size:14px;}
        .fp-hint{font-size:12px;color:rgba(255,255,255,0.25);margin-top:6px;display:flex;align-items:center;gap:5px;}
        .fp-btn{width:100%;padding:13px;background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;border:none;border-radius:12px;font-size:15px;font-weight:700;cursor:pointer;font-family:'DM Sans',sans-serif;display:flex;align-items:center;justify-content:center;gap:8px;box-shadow:0 8px 20px rgba(102,126,234,0.35);transition:all 0.2s;margin-bottom:20px;}
        .fp-btn:hover:not(:disabled){transform:translateY(-1px);}
        .fp-btn:disabled{opacity:0.65;cursor:not-allowed;}
        .fp-links{display:flex;align-items:center;justify-content:center;gap:12px;}
        .fp-link{color:rgba(102,126,234,0.9);text-decoration:none;font-size:13px;font-weight:700;}
        .fp-sep{color:rgba(255,255,255,0.15);font-size:13px;}
        .fp-info{background:rgba(102,126,234,0.08);border:1px solid rgba(102,126,234,0.2);border-radius:12px;padding:14px 16px;margin-top:20px;}
        .fp-info-title{font-size:13px;font-weight:700;color:rgba(255,255,255,0.6);margin-bottom:8px;display:flex;align-items:center;gap:7px;}
        .fp-info-step{font-size:12px;color:rgba(255,255,255,0.35);line-height:1.8;padding-left:4px;}
        /* Success state */
        .fp-success-icon{width:72px;height:72px;background:rgba(16,185,129,0.15);border:1px solid rgba(16,185,129,0.3);border-radius:20px;display:flex;align-items:center;justify-content:center;margin:0 auto 20px;animation:fp-pop 0.4s ease;}
        @keyframes fp-pop{from{transform:scale(0.7);opacity:0;}to{transform:scale(1);opacity:1;}}
        .fp-success-title{font-family:'Syne',sans-serif;font-size:22px;font-weight:800;color:#fff;text-align:center;margin-bottom:10px;}
        .fp-success-sub{font-size:14px;color:rgba(255,255,255,0.4);text-align:center;line-height:1.7;}
        .fp-redirect{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:20px;font-size:13px;color:rgba(255,255,255,0.3);}
        @media(max-width:480px){.fp-card{padding:32px 22px;border-radius:20px;}.fp-title{font-size:20px;}}
      `}</style>

      <div className="fp-page">
        <div className="fp-orb1" /><div className="fp-orb2" />

        <div className="fp-card">
          {/* Logo */}
      <div className="fp-logo">
  <img 
    src={`${process.env.PUBLIC_URL}/janimony-logo.png`} 
    alt="Janimony" 
    style={{ width: '100px', height: 'auto', objectFit: 'contain' }}
  />
</div>

          {success ? (
            /* Success state */
            <>
              <div className="fp-success-icon">
                <i className="fa-solid fa-envelope-circle-check" style={{ color: '#10b981', fontSize: 30 }}></i>
              </div>
              <h2 className="fp-success-title">Check Your Email</h2>
              <p className="fp-success-sub">
                We've sent a 6-digit OTP code to:<br />
                <strong style={{ color: 'rgba(255,255,255,0.7)' }}>{email}</strong>
              </p>
              <p className="fp-success-sub" style={{ marginTop: 10, fontSize: 13 }}>
                The code expires in 10 minutes.
              </p>
              <div className="fp-redirect">
                <i className="fa-solid fa-spinner fa-spin"></i>
                Redirecting to verification…
              </div>
            </>
          ) : (
            /* Form */
            <>
              <div className="fp-icon-wrap">
                <i className="fa-solid fa-lock" style={{ color: '#a5b4fc', fontSize: 28 }}></i>
              </div>
              <h1 className="fp-title">Forgot Password?</h1>
              <p className="fp-sub">
                No worries — enter your email and we'll send you a one-time code to reset your password.
              </p>

              {error && (
                <div className="fp-alert fp-err">
                  <i className="fa-solid fa-circle-exclamation" style={{ flexShrink: 0 }}></i>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="fp-grp">
                  <label className="fp-lbl">Email Address</label>
                  <div className="fp-wrap">
                    <i className="fa-solid fa-envelope fp-ico"></i>
                    <input
                      className="fp-inp"
                      type="email"
                      placeholder="you@company.com"
                      value={email}
                      onChange={e => { setEmail(e.target.value); setError(''); }}
                      required
                      autoComplete="email"
                      autoFocus
                    />
                  </div>
                  <p className="fp-hint">
                    <i className="fa-solid fa-circle-info"></i>
                    We'll send a 6-digit OTP code to this email
                  </p>
                </div>

                <button type="submit" className="fp-btn" disabled={loading}>
                  {loading
                    ? <><i className="fa-solid fa-spinner fa-spin"></i>Sending OTP…</>
                    : <><i className="fa-solid fa-paper-plane"></i>Send OTP Code</>}
                </button>
              </form>

              <div className="fp-links">
                <Link to="/login" className="fp-link">
                  <i className="fa-solid fa-arrow-left" style={{ marginRight: 5, fontSize: 11 }}></i>
                  Back to Login
                </Link>
                <span className="fp-sep">•</span>
                <Link to="/signup" className="fp-link">Create Account</Link>
              </div>

              <div className="fp-info">
                <div className="fp-info-title">
                  <i className="fa-solid fa-circle-info" style={{ color: '#667eea' }}></i>
                  What happens next
                </div>
                <div className="fp-info-step">
                  1. We send a 6-digit code to your email<br />
                  2. Enter the code on the next page<br />
                  3. Create your new password<br />
                  4. Log in with your new credentials
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;